export default {
    ListLoading: 'user:taskMessage:ListLoading', // 流加载
    TaskMessageListGET: 'user:taskMessage:TaskMessageListGET', // 获取通知列表
    TaskMessageListPage: 'user:taskMessage:TaskMessageListPage', // 获取通知分页
    TaskMessageGet: 'user:taskMessage:TaskMessageGet', // 查阅消息
};



// WEBPACK FOOTER //
// ./pages/user/taskMessage/constant.js